module.exports = __webpack_public_path__ + "static/hymots-website-mainPage-1-37ef8e432bfaf7c3d91ba45861b7c381.png";